export default __webpack_public_path__ + "static/media/iceAge.f6ecb0ab.png";